import { CaptureStepTypes } from "@enums/capture-step-types";
import { ValidationResult } from "@idw-types/common/validation-result";
import { ValidationTypes } from "@enums/validation-types";
import { CaptureStepValidationResults, ValidationResults } from "../../types/data/validation-results";

export enum ValidationResultsActionTypes {
    INITIALIZE_VALIDATION_RESULTS = "INITIALIZE_VALIDATION_RESULTS",
    SET_CAPTURE_STEP_VALIDATION_RESULT = "SET_CAPTURE_STEP_VALIDATION_RESULT",
    SET_CAPTURE_STEP_VALIDATION_RESULTS = "SET_CAPTURE_STEP_VALIDATION_RESULTS"
}

type InitializeValidationResultsAction = {
    type: ValidationResultsActionTypes.INITIALIZE_VALIDATION_RESULTS,
    payload: {
        validationResults: ValidationResults;
    }
};

export const initializeValidationResults = (validationResults: ValidationResults): InitializeValidationResultsAction => ({
    type: ValidationResultsActionTypes.INITIALIZE_VALIDATION_RESULTS,
    payload: { validationResults }
});

type SetCaptureStepValidationResultAction = {
    type: ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULT;
    payload: {
        captureStepType: CaptureStepTypes;
        validationType: ValidationTypes;
        validationResult: ValidationResult;
    };
};

export const setCaptureStepValidationResult = (captureStepType: CaptureStepTypes, validationType: ValidationTypes, validationResult: ValidationResult): SetCaptureStepValidationResultAction => ({
    type: ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULT,
    payload: { captureStepType, validationType, validationResult }
});

type SetCaptureStepValidationResultsAction = {
    type: ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULTS;
    payload: {
        captureStepType: CaptureStepTypes;
        captureStepValidationResults: CaptureStepValidationResults;
    };
};

export const setCaptureStepValidationResults = (captureStepType: CaptureStepTypes, captureStepValidationResults: CaptureStepValidationResults): SetCaptureStepValidationResultsAction => ({
    type: ValidationResultsActionTypes.SET_CAPTURE_STEP_VALIDATION_RESULTS,
    payload: { captureStepType, captureStepValidationResults }
});

export type ValidationResultsActions =
    InitializeValidationResultsAction |
    SetCaptureStepValidationResultAction |
    SetCaptureStepValidationResultsAction;